(function(angular) {
    'use strict';

    angular.module('aprima-legacy-common').factory('SecurityRepository', [
        '_',
        '$q',
        'AprimaCache',
        'AprimaRestangular',
        SecurityRepository
    ]);

    function SecurityRepository(
        _,
        $q,
        AprimaCache,
        AprimaRestangular
    ) {

        var defaultCache = AprimaCache.Permissions.httpMode;

        var service = {
            getPermissions: getPermissions
        };

        return service;

        function getPermissions(permissionName) {
            var promise = AprimaRestangular.get()
                .one('permissions', permissionName)
                .withHttpConfig({cache: defaultCache})
                .get()
                .then(function (securityPermission) {
                    if (!securityPermission) {
                        return $q.reject('No permission matches \'' + permissionName + '\'');
                    }

                    // Handle legacy case where IsAllowed wasn't a property on the object
                    if (!_.has(securityPermission, 'IsAllowed')) {
                        securityPermission.IsAllowed = true;
                    }
                    return securityPermission;
                });

            return promise;
        }
    }

})(window.angular);
